import { Component } from '@angular/core';

import { TealiumUtagService } from '../tealium/utag.service';
import { ElementsOverviewComponent } from '../components/elements/elements-overview';
import { ElementsFeaturesComponent } from '../components/elements/elements-features';
import { ElementsCharactersComponent } from '../components/elements/elements-characters';
import { ElementsPlatformsComponent } from '../components/elements/elements-platforms';
import { ElementsResourcesComponent } from '../components/elements/elements-resources';

@Component({
  selector: 'stars-elements-page',
  templateUrl: './elements.html',
  styleUrls: ['./elements.scss'],
  providers: [TealiumUtagService],
  imports: [
    ElementsOverviewComponent,
    ElementsFeaturesComponent,
    ElementsCharactersComponent,
    ElementsPlatformsComponent,
    ElementsResourcesComponent
  ]
})
export class ElementsPageComponent {}
